import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {AuthPanelPage} from "./AuthPanelPage.jsx";
import {Messages} from "../../Messages.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {MessageElement} from "../../widget/ui/MessageElement.jsx";


export class SubscribeAuthPage extends AuthPanelPage {
    render() {
        return [
            Messages.subscribeInlineAuth1.toString().trim() &&
                <MessageElement
                    message={Messages.subscribeInlineAuth1(iFrameMerchantService.getMerchant().name)}
                    className={this.styleSheet.message}
                />,
            super.render()
        ];
    }
}
